module.exports = __webpack_public_path__ + "static/media/recommendation_critical_risk.421c31fa.svg";